import angular from 'angular';

/**
 * @param {string} input
 * @returns {string}
 */
function nodeLink(input) {
	// noinspection HtmlUnknownTarget
	return input.replaceAll(/(K_NODE;[\dA-Za-z]+)/g, '<a href="/admin/oo/$1">$1</a>');
}

/* @ngInject */
/**
 * @returns {Function}
 */
function nodeLinkFilter() {
	return (/** @type {string} */ input) => nodeLink(input);
}

/**
 * @memberOf app
 * @ngdoc filter
 * @name app.filter:nodeLink
 * @function
 * @description
 * # nodeLink
 * Adds a OO admin link to the specified KID string.
 *
 * @example
 *   Usage:
 *   <p>{{ KID | nodeLink }}</p>
 *
 *   <p>{{ 'K_NODE;PERSON' | nodeLink }}</p> // returns <p><a href="/admin/oo/K_NODE;PERSON">K_NODE;PERSON</a></p>
 */
angular.module('app')
	.filter('nodeLink', nodeLinkFilter);
